<script setup lang="ts">
const { cookieConsent } = useCommonStore();

const currentYear = new Date().getFullYear();
</script>

<template>
	<div class="border-t border-t-gray">
		<div class="box-content max-w-[1400px] py-6 px-6 m-auto flex items-center justify-between text-green-dark xs:px-4">
			<button
				class="text-sm hover:text-black"
				@click="cookieConsent.isSeen = false"
			>
				{{ $t('cookiePreferences') }}
			</button>
			<small class="text-sm xs:hidden">©{{ currentYear }} Valley Arts</small>
			<div class="flex gap-x-4">
				<LayoutFooterBottomLanguageMenu />
			</div>
		</div>
		<div class="hidden xs:flex text-green-dark justify-center py-2 px-2 border-t border-t-gray">
			<small class="text-[11px]">©{{ currentYear }} Valley Arts</small>
		</div>
	</div>
</template>
